import React from "react"

import AdminPage from "@/components/admin/AdminPage"
import ExportsContent from "@/components/admin/ExportsContent"

const Exports: React.FC = () => (
  <AdminPage>
    <ExportsContent />
  </AdminPage>
)

export default Exports
